const createAdminRouter = (routerName: string) => {
    return {
        name: 'admin/' + routerName,
        list: '/admin/' + routerName + '/list',
        add: '/admin/' + routerName + '/add',
        edit: '/admin/' + routerName + '/edit/:id',
        detail: '/admin/' + routerName + '/detail/:id',
    }
}

const createKiotRouter = (routerName: string) => {
    return {
        name: 'kiot/' + routerName,
        list: '/kiot/' + routerName + '/list',
        add: '/kiot/' + routerName + '/add',
        edit: '/kiot/' + routerName + '/edit/:id',
        detail: '/kiot/' + routerName + '/detail/:id',
    }
}

const creatOrderRouter = (routerName: string) => {
    return {
        name: 'kho/' + routerName,
        list: '/kho/' + routerName + '/list',
        add: '/kho/' + routerName + '/add',
        edit: '/kho/' + routerName + '/edit/:id',
        detail: '/kho/' + routerName + '/detail/:id',
    }
}

export default {
    public: {
    },
    user: {
        ...createAdminRouter('user'),
        changePWD: '/admin/user/doi-mat-khau'
    },
    customer: createKiotRouter('customer'),
    category: createKiotRouter('category'),
    product: createKiotRouter('product'),
    order: {
        ...creatOrderRouter('order'),
        donHangAll: '/kho/order-all/list',
        donHangPick: '/kho/order-pick/list',
        donHangCheck: '/kho/order-check/list',
        donHangPack: '/kho/order-pack/list',
        donHangSchedule: '/kho/order-schedule/list',
        donHangShip: '/kho/order-ship/list',
        donHangManage: '/kho/order-manage/list',
        donHangSync: '/kho/order-sync/list',
    },
   
    notification: {
        ...createAdminRouter('notification'),
        list: '/admin/notification/list',
        add: '/admin/notification/add',
        edit: '/admin/notification/edit/:id',
        detail: '/admin/notification/detail/:id',
        import: '/admin/notification/import',
        send: '/admin/notification/send',
    },

    invoice: {
        ...creatOrderRouter('invoice')
    },
    report: {
        ...createAdminRouter('report'),
        list: '/admin/report/list',
        /** Báo cáo theo đơn (một dòng/đơn, workflow, không chi tiết dòng hàng) */
        orderList: '/admin/report/don-hang',
    },
    syncKiot: {
        name: 'kho/sync-kiot',
        sync: '/kho/sync-kiot',
    },
    kiotRetailer: {
        name: 'kho/kiot-retailer',
        saleLogin: '/kho/kiot-retailer/dang-nhap-sale',
    },
    chiNhanh: {
        name: 'kho/chi-nhanh',
        capNhatThongTin: '/kho/chi-nhanh/cap-nhat-thong-tin',
    },

}
